import i18n from '../i18nService';
import { productsStorage } from './productsStorage';

const resolveProduct = (productOrCode) => {
    if (productOrCode && typeof productOrCode === 'object') {
        const fromStorage = productsStorage.productsList.find(
            (it) => it.id === productOrCode.id || it.productCode === productOrCode.productCode,
        );
        return fromStorage ?? productOrCode;
    }
    if (typeof productOrCode === 'string') {
        return productsStorage.productsList.find((it) => it.productCode === productOrCode);
    }
    return null;
};

const getNameFromProduct = (product, localeCode) => {
    if (product?.names?.length) {
        const found = product.names.find((it) => it.locale === localeCode);
        if (found?.name) {
            return found.name;
        }
    }
    return '';
};

export const productNamesService = {
    getLocalization(localeCode, productOrCode, withCodeReplace = false) {
        const product = resolveProduct(productOrCode);
        const code = product?.productCode ?? (typeof productOrCode === 'string' ? productOrCode : '');
        const apiName = product ? getNameFromProduct(product, localeCode) : '';
        if (apiName) {
            return apiName;
        }
        return withCodeReplace ? code : '';
    },
    getPlaceholder(i18nInstance = i18n) {
        return i18nInstance.t('app.page.product.addProductItem.productName');
    },
};
